var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import produce from 'immer';
export var getInitialState = function () { return ({
    loading: false,
    updating: false,
    error: false,
    basic: {},
    preview: {
        color: '',
        typography: '',
    },
    personalization: [],
    env: [],
    files: [],
    filesMeta: {},
    folders: [],
    foldersMeta: {},
    currentStep: 1,
    deleteEnvPopup: false,
    resetEnvPopup: false,
    sectionNumber: 1,
    templateId: '',
    template_status: false,
    template_global: false,
    ds_shared_app: false,
}); };
function templateReducer(currentState, action) {
    if (currentState === void 0) { currentState = getInitialState(); }
    return produce(currentState, function (state) {
        switch (action.type) {
            case 'ADD_TEMPLATE_ID_SUCCESS':
                state.loading = false;
                state.error = false;
                state.templateId = action.templateId || '';
                break;
            case 'ADD_TEMPLATE_ID_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'UPDATE_TEMPLATE_DATA_SUCCESS':
                state.loading = false;
                state.error = false;
                state.templateId = action.appData.template || '';
                state.template_status = action.appData.template_status || false;
                state.template_global = action.appData.template_global || false;
                state.ds_shared_app = action.appData.ds_shared_app || false;
                break;
            case 'UPDATE_TEMPLATE_DATA_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'DELETE_APP_TEMPLATES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'DELETE_APP_TEMPLATES_SUCCESS':
                state.loading = false;
                state.error = false;
                state.templateId = '';
                state.template_status = false;
                state.template_global = false;
                state.ds_shared_app = false;
                break;
            case 'DELETE_APP_TEMPLATES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'CREATE_BASIC_TEMPLATE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.basic = action.basicDetails || {};
                break;
            case 'CREATE_SELECTED_VIEW_ADD_SUCCESS':
                state.loading = false;
                state.error = false;
                state.preview = action.selectedViews || {};
                break;
            case 'CREATE_BASIC_TEMPLATE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'CREATE_SELECTED_VIEW_ADD_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'CHANGE_CURRENT_STEP_SUCCESS':
                state.currentStep = action.currentStep || 1;
                break;
            case 'CREATE_PERSONALIZATION_TEMPLATE_SUCCESS':
            case 'UPDATE_PERSONALIZATION_TEMPLATE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.personalization = action.personalization || [];
                break;
            case 'UPDATE_ENVIRONMENT_VARIABLES_SUCCESS':
                state.loading = false;
                state.error = false;
                state.env = action.env || [];
                break;
            case 'UPDATE_ENVIRONMENT_DELETE_POPUP_SUCCESS':
                state.loading = false;
                state.error = false;
                state.deleteEnvPopup = action.deletePopup || false;
                break;
            case 'UPDATE_ENVIRONMENT_RESET_POPUP_SUCCESS':
                state.loading = false;
                state.error = false;
                state.resetEnvPopup = action.resetEnvPopup || false;
                break;
            case 'UPDATE_SECTION_NUMBER_SUCCESS':
                state.loading = false;
                state.error = false;
                state.sectionNumber = action.sectionNumber || 1;
                break;
            case 'UPDATE_SECTION_HEADER_SUCCESS':
                state.loading = false;
                state.error = false;
                currentState.personalization.find(function (item) { return item.id === action.id; }).heading = action.header;
                state.personalization = __spreadArray([], currentState.personalization, true) || [];
                break;
            case 'REMOVE_SECTION_HEADER_SUCCESS':
                state.loading = false;
                state.error = false;
                var current = currentState.personalization.filter(function (item) { return item.id !== action.id; });
                state.personalization = __spreadArray([], current, true) || [];
                break;
            case 'REMOVE_SECTION_ENV_SUCCESS':
                state.loading = false;
                state.error = false;
                if (currentState.env.length !== 0) {
                    currentState.env.find(function (item) { return item.column === action.id; }).column =
                        'START';
                }
                state.env = __spreadArray([], currentState.env, true) || [];
                break;
            case 'CREATE_PERSONALIZATION_TEMPLATE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'UPDATE_PERSONALIZATION_TEMPLATE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'UPDATE_ENVIRONMENT_VARIABLES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'DELETE_PERSONALIZATION_TEMPLATE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.personalization = state.personalization.filter(function (l) { return l.id !== action.pId; });
                break;
            case 'STATE_LOAD_FOLDERS_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'STATE_LOAD_FOLDERS_SUCCESS':
                state.folders = action.folders || [];
                state.foldersMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case 'STATE_LOAD_FOLDERS_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'ENVIRONMENT_DELETE_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'ENVIRONMENT_DELETE_SUCCESS':
                state.loading = false;
                state.error = false;
                break;
            case 'ENVIRONMENT_DELETE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'RESET_TEMPLATE_SUCCESS':
                state.loading = false;
                state.error = false;
                state.updating = false;
                state.basic = {};
                state.preview = {
                    color: '',
                    typography: '',
                };
                state.personalization = [];
                state.env = [];
                state.files = [];
                state.filesMeta = {};
                state.folders = [];
                state.foldersMeta = {};
                state.currentStep = 1;
                state.deleteEnvPopup = false;
                state.resetEnvPopup = false;
                state.sectionNumber = 1;
                state.templateId = '';
                break;
            case 'RESET_TEMPLATE_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'STATE_LOAD_FILES_REQUEST':
                state.loading = true;
                state.error = false;
                break;
            case 'STATE_LOAD_FILES_SUCCESS':
                state.files = action.files || [];
                state.filesMeta = action.meta;
                state.loading = false;
                state.error = false;
                break;
            case 'STATE_LOAD_FILES_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'UPDATE_ENVIRONMENT_DELETE_POPUP_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'UPDATE_ENVIRONMENT_RESET_POPUP_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            case 'UPDATE_SECTION_NUMBER_FAILURE':
                state.loading = false;
                state.error = true;
                break;
            default:
                break;
        }
    });
}
export default templateReducer;
